import ApiBaseRepository from './apibase';
/**
 * @summary axios
 * @param S Successedのtype
 * @returns 型定義済みデータ
 */
export default class ApiManager {
    static get(url, params) {
        return new Promise((resolve, reject) => {
            ApiBaseRepository.get(url, { params: params })
                .then((res) => {
                const data = res.data;
                resolve(data);
            })
                .catch((err) => {
                reject(err);
            });
        });
    }
    static post(url, body) {
        return new Promise((resolve, reject) => {
            ApiBaseRepository.post(url, body)
                .then((res) => {
                const data = res.data;
                resolve(data);
            })
                .catch((err) => {
                reject(err);
            });
        });
    }
    static put(url, body) {
        return new Promise((resolve, reject) => {
            ApiBaseRepository.put(url, body)
                .then((res) => {
                const data = res.data;
                resolve(data);
            })
                .catch((err) => {
                reject(err);
            });
        });
    }
    static patch(url, body) {
        return new Promise((resolve, reject) => {
            ApiBaseRepository.patch(url, body)
                .then((res) => {
                const data = res.data;
                resolve(data);
            })
                .catch((err) => {
                reject(err);
            });
        });
    }
    static delete(url) {
        return new Promise((resolve, reject) => {
            ApiBaseRepository.delete(url)
                .then((res) => {
                const data = res.data;
                resolve(data);
            })
                .catch((err) => {
                reject(err);
            });
        });
    }
}
